export default __webpack_public_path__ + "static/media/heather.c69014c2.jpg";